import React, { useState } from 'react';
import { Button, Card, Form } from 'react-bootstrap';
import { CursosExternosService } from '../../../../service/cursosExternos.service';
import { CursoExterno } from '../../../../service/types/cursosExternos.types';
import { FeedbackModal } from '../../feedback.modal';

interface CursoExternoFormProps {
  initialValue?: CursoExterno;
  onSaved: (curso: CursoExterno) => void;
  onCancel?: () => void;
}

export default function CursoExternoForm({ initialValue, onSaved, onCancel }: CursoExternoFormProps) {
  const [nombre, setNombre] = useState(initialValue?.nombre ?? '');
  const [descripcion, setDescripcion] = useState(initialValue?.descripcion ?? '');
  const [link, setLink] = useState(initialValue?.link ?? '');
  const [activo, setActivo] = useState(initialValue?.activo ?? true);
  const [saving, setSaving] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState<'success' | 'error'>('success');
  const [modalMessage, setModalMessage] = useState('');

  const isEditing = !!initialValue?.id;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!nombre.trim()) {
      alert('Ingrese un nombre para el curso');
      return;
    }
    if (!link.trim()) {
      alert('Ingrese el link externo del curso');
      return;
    }
    setSaving(true);
    try {
      const curso = isEditing
        ? await CursosExternosService.update(initialValue!.id, { nombre, descripcion, link, activo })
        : await CursosExternosService.create({ nombre, descripcion, link, activo });
      setModalType('success');
      setModalMessage(isEditing ? 'Curso externo actualizado correctamente' : 'Curso externo creado correctamente');
      setShowModal(true);
      onSaved(curso);
    } catch (error) {
      setModalType('error');
      setModalMessage('Error al guardar el curso externo');
      setShowModal(true);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Card className="mb-3">
      <FeedbackModal
        show={showModal}
        onHide={() => setShowModal(false)}
        type={modalType}
        message={modalMessage}
        autoClose
        duration={2500}
      />
      <Card.Header>{isEditing ? 'Editar curso externo' : 'Crear curso externo'}</Card.Header>
      <Card.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Nombre</Form.Label>
            <Form.Control
              type="text"
              value={nombre}
              onChange={(e) => setNombre(e.target.value)}
              placeholder="Ej: Curso de manejo defensivo (SENCE)"
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Descripción</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={descripcion}
              onChange={(e) => setDescripcion(e.target.value)}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Link externo</Form.Label>
            <Form.Control
              type="text"
              value={link}
              onChange={(e) => setLink(e.target.value)}
              placeholder="https://..."
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Check
              type="checkbox"
              label="Activo"
              checked={activo}
              onChange={(e) => setActivo(e.target.checked)}
            />
          </Form.Group>
          <div className="d-flex gap-2">
            <Button type="submit" variant="success" disabled={saving}>
              {saving ? 'Guardando...' : isEditing ? 'Guardar cambios' : 'Crear curso externo'}
            </Button>
            {onCancel && (
              <Button variant="secondary" onClick={onCancel} disabled={saving}>
                Cancelar
              </Button>
            )}
          </div>
        </Form>
      </Card.Body>
    </Card>
  );
}
